"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  overflow: ", ";\n"], ["\n  position: relative;\n  display: block;\n  overflow: ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _PopoverButton = require("./PopoverButton");

var _PopoverButton2 = _interopRequireDefault(_PopoverButton);

var _PopoverMessage = require("./PopoverMessage");

var _PopoverMessage2 = _interopRequireDefault(_PopoverMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Popover = _styledComponents2.default.div.withConfig({
  displayName: "src__Popover",
  componentId: "sc-2ghc82-0"
})(_templateObject, function (props) {
  return props.show ? 'visible' : 'hidden';
});

var PopoverContainer = function (_React$Component) {
  _inherits(PopoverContainer, _React$Component);

  function PopoverContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PopoverContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopoverContainer.__proto__ || Object.getPrototypeOf(PopoverContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: false,
      position: {
        down: false,
        x: null
      },
      up: false,
      y: 0
    }, _this.getMouseDirection = function (e) {
      // determine if user mouse is going up or not 
      _this.state.y > e.pageY ? _this.setState({ up: true }) : _this.setState({ up: false });

      _this.setState({ y: e.pageY });
    }, _this.onClick = function () {
      var pos = _this.state.position;
      var msgCoords = _this.message.getBoundingClientRect();
      pos.x = null;
      pos.down = false;

      if (!_this.state.show) {
        pos.down = msgCoords.top < 0;

        if (msgCoords.right > window.innerWidth) {
          pos.x = window.innerWidth - msgCoords.right - msgCoords.width / 2;
        } else if (msgCoords.left < 0) {
          pos.x = -(msgCoords.x + msgCoords.width / 2);
        }
      }
      _this.setState({ show: !_this.state.show, position: pos });
    }, _this.onHover = function (hoverState) {
      var msgHoverState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!_this.props.hoverable) return;
      // if mouse is hovering up into tooltip message dont hide
      if (!hoverState && _this.state.up && !msgHoverState) return;
      // on mouse leave, remove focus from popover
      else if (!hoverState) _this.handleBlur();else _this.setState({ show: hoverState });
    }, _this.handleClickOutside = function () {
      _this.setState({
        show: false,
        position: {
          down: false,
          x: null
        }
      });
    }, _this.handleFocus = function (focusState) {
      _this.setState({ show: focusState });
    }, _this.handleBlur = function () {
      _this.setState({ show: false });
      _this.popover.blur();
    }, _this.onKeyDown = function (e) {
      var key = e.keyCode;
      // exit tooltip and remove focus on esc
      if (key === 27) {
        _this.setState({ show: false });
        _this.handleBlur();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PopoverContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // added to popover so it does not listen to mouse movement outside of the popover button
      this.popover.addEventListener("mousemove", this.getMouseDirection);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.popover.removeEventListener("mousemove", this.getMouseDirection);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        Popover,
        {
          show: this.state.show,
          onMouseEnter: function onMouseEnter() {
            return _this2.onHover(true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this2.onHover(false);
          },
          tabIndex: "0",
          onFocus: function onFocus() {
            return _this2.handleFocus(true);
          },
          onBlur: this.handleBlur,
          onKeyDown: this.onKeyDown,
          "aria-describedby": this.props.id,
          innerRef: function innerRef(p) {
            return _this2.popover = p;
          }
        },
        _react2.default.createElement(
          _PopoverMessage2.default,
          {
            position: this.state.position,
            innerRef: function innerRef(m) {
              return _this2.message = m;
            },
            show: this.state.show,
            onMouseLeave: function onMouseLeave() {
              return _this2.onHover(false, true);
            }
          },
          this.props.message && this.props.message,
          this.props.children
        ),
        _react2.default.createElement(_PopoverButton2.default, { onClick: this.onClick, buttonRef: function buttonRef(b) {
            return _this2.button = b;
          } })
      );
    }
  }]);

  return PopoverContainer;
}(_react2.default.Component);

PopoverContainer.defaultProps = {
  hoverable: false
};

exports.default = (0, _reactOnclickoutside2.default)(PopoverContainer);


//////////////////
// WEBPACK FOOTER
// ./~/buoy-popover/dist/index.js
// module id = 437
// module chunks = 168707334958949